export class ValidationProviderDetails {
  id: number;
  active: boolean;
  label: string;
}
